<template>
  <div
    class="booking-progressbar"
    data-component="booking-progressbar"
  >
    <div class="booking-progressbar-wrapper">
      <div
        ref="statusMessage"
        role="status"
        class="sr-only"
      >
        <span v-if="currentStepMessage">{{ currentStepMessage }}</span>
      </div>
      <div class="booking-progressbar-steps">
        <button
          v-if="!isBookingEditMode"
          class="booking-progressbar-step"
          @click.prevent="$emit('edit', ['confirmation', $event.target])"
        >
          <span class="circle">1</span>
          <span class="label">{{ tc('booking.propertyGuestsAndDates') }}</span>
        </button>
        <button
          v-for="step in updatedStepsData"
          :key="step.stepId"
          :ref="isActive(step.stepIntId) ? 'activeStep' : null"
          class="booking-progressbar-step"
          :class="isActive(step.stepIntId) && 'active'"
          :disabled="isDisabled(step.stepIntId)"
          @click="buttonAction(step)"
        >
          <span class="circle">{{ step.stepNumber }}</span>
          <span class="label">{{ tc(step.label) }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    name: 'BookingProgressBar',
    components: {
    },
    data: () => ({
      bookingSteps: [
        {
          stepId: 'room-list',
          stepIntId: 0,
          stepNumber: 2,
          label: 'booking.roomsPackages',
          forLogged: true,
          forNonLogged: true,
          overviewRoute: 'rooms-overview'
        },
        {
          stepId: 'join-fans',
          stepIntId: 1,
          stepNumber: 3,
          label: 'booking.enhancementStepLabel',
          forLogged: false,
          forNonLogged: true,
          overviewRoute: 'privileges-overview'
        },
        {
          stepId: 'enhancements',
          stepIntId: 2,
          stepNumber: 3,
          label: 'booking.enhancementStepLabel',
          forLogged: true,
          forNonLogged: false,
          overviewRoute: 'privileges-overview'
        },
        {
          stepId: 'check-out',
          stepIntId: 3,
          stepNumber: 4,
          label: 'booking.checkOut',
          forLogged: true,
          forNonLogged: true
        },
      ],
      editModeBookingSteps: [
        {
          stepId: 'room-list',
          stepIntId: 0,
          stepNumber: 1,
          label: 'booking.roomsPackages',
          forLogged: true,
          forNonLogged: true,
          overviewRoute: 'rooms-overview'
        },
        {
          stepId: 'join-fans',
          stepIntId: 1,
          stepNumber: 2,
          label: 'booking.enhancementStepLabel',
          forLogged: false,
          forNonLogged: true,
          overviewRoute: 'privileges-overview'
        },
        {
          stepId: 'enhancements',
          stepIntId: 2,
          stepNumber: 2,
          label: 'booking.enhancementStepLabel',
          forLogged: true,
          forNonLogged: false,
          overviewRoute: 'privileges-overview'
        },
        {
          stepId: 'check-out',
          stepIntId: 3,
          stepNumber: 3,
          label: 'booking.guestDetails',
          forLogged: true,
          forNonLogged: true
        },
      ],
      currentStepMessage: '',
    }),
    computed: {
      ...mapState('booking', ['query']),
      ...mapGetters('auth', ['isAuthenticated']),
      ...mapGetters('booking', ['getStep']),
      ...mapGetters('i18n', ['tc']),
      ...mapState('modifyReservation', ['isBookingEditMode']),
      currentStep() {
        return this.getStep
      },
      isMultiRoom() {
        return Number(this.query.roomQuantity) > 1
      },
      updatedStepsData() {
        const { isAuthenticated } = this
        const steps = this.isBookingEditMode ? this.editModeBookingSteps : this.bookingSteps
        return steps.filter((step) => {
          if (isAuthenticated) return step.forLogged
          return step.forNonLogged
        })
      }
    },
    watch: {
      currentStep: {
        immediate: true,
        handler(newStep) {
          this.$nextTick(() => {
            setTimeout(() => {
              const steps = this.isBookingEditMode ? this.editModeBookingSteps : this.bookingSteps
              const activeStep = steps.find((s) => s.stepIntId === newStep)
              if (activeStep) {
                this.currentStepMessage = this.getAriaLabel(activeStep)
                if (this.$refs.activeStep && this.$refs.activeStep[0]) {
                  this.$refs.activeStep[0].focus()
                }
              }
            }, 100)
          })
        }
      }
    },
    methods: {
      ...mapActions('booking', ['goToStep', 'validateRoute', 'updateStep']),
      buttonAction(step) {
        const { stepId, stepIntId, overviewRoute } = step
        if (stepIntId === this.currentStep) return
        if (this.isMultiRoom && (stepId === 'enhancements' || stepId === 'join-fans' || stepId === 'room-list')) {
          this.$router.push({
            name: overviewRoute,
            query: {
              ...this.$route.query
            }
          }).then(() => {
            this.updateStep(stepId)
          })
        } else {
          this.goToStep(stepId)
        }
      },
      isActive(stepIntId) {
        return stepIntId === this.currentStep
      },
      isDisabled(stepIntId) {
        return stepIntId > this.currentStep
      },
      getAriaLabel(step) {
        return `${this.tc('accessibility.stepNumber', { number: step.stepNumber })}, ${this.tc(step.label)} ${this.isActive(step.stepIntId) ? `, ${this.tc('accessibility.currentStep')}` : ''}`
      }
    }
  }
</script>
